/* eslint-disable array-callback-return */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import SaveIcon from '@mui/icons-material/Save';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import OwnDatePickersWithFunc from '../components/DatePickersWithFunc';
import OwnTimePickersWithFunc from '../components/TimePickersWithFunc';
import FileUpload from '../components/FileUpload';
import { CalTimeSpan } from '../components/TimeDiffCal';
import AlertDialog from '../components/AlertDialog';
import { toast} from 'react-toastify'
import axios from 'axios';

/*-------------------- Class Component --------------------*/
class PageUpdateAndRecordLeave extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curr_persid: '',
      curr_studid: '',
      curr_studlistid: '',
      courseid: '',
      classattendid: '',
      leavestartdate: '',
      leavestarttime: '',
      leaveenddate: '',
      leaveendtime: '',
      coursegrplist: [],
      seminarlist: [],
      instrlist: [],
      selcoursegrp: '',
      selseminar: '',
      selcoursegrp_indx: '',
      selseminar_indx: '',
      selleavetype_indx: '',
      leavehrs: 0.0,
      leavereason: '',
      addnewleave: 0,
      uploadfilepath: '',
      newlocalstorage: '',
      loading: true,
      openAlertDialog: false,
    };

    this.fileUploadRef = React.createRef();
    this.handleCourseGrpSelect = this.handleCourseGrpSelect.bind(this);
    this.handleSeminarSelect = this.handleSeminarSelect.bind(this);
    this.handleInstructorOnChange = this.handleInstructorOnChange.bind(this);
    this.handleLeaveTypeOnChange = this.handleLeaveTypeOnChange.bind(this);
    this.handleLeaveStartDateOnChange = this.handleLeaveStartDateOnChange.bind(this);
    this.handleLeaveStartTimeOnChange = this.handleLeaveStartTimeOnChange.bind(this);
    this.handleLeaveEndDateOnChange = this.handleLeaveEndDateOnChange.bind(this);
    this.handleLeaveEndTimeOnChange = this.handleLeaveEndTimeOnChange.bind(this);
    this.handleLeaveReasonOnchange = this.handleLeaveReasonOnchange.bind(this);
    this.handleBtnRecOnClick = this.handleBtnRecOnClick.bind(this);
    this.handleBtnGoBackOnClick = this.handleBtnGoBackOnClick.bind(this);
  }

  componentDidMount() {
    this.createIntructorList();
    this.getStudListIdFromLocalStorage();
    this.setState({
      addnewleave: (this.props.location.state.addleave ? 1 : 0),
      selleavetype_indx: this.leaveTypeMgmt(this.props.location.state.sel_student.leavetype),
      classattendid: this.props.location.state.sel_student.classattendid,
      leavestartdate: this.props.location.state.sel_student.leavestartdate,
      leavestarttime: this.props.location.state.sel_student.leavestarttime,
      leaveenddate: this.props.location.state.sel_student.leaveenddate,
      leaveendtime: this.props.location.state.sel_student.leaveendtime,
      leavehrs: this.props.location.state.sel_student.leavehrs,
      leavereason: this.props.location.state.sel_student.leavereason
    });
  }

  leaveTypeMgmt = (type) => {
    switch (type) {
      case 'ลาป่วย':
        return 0;
      case 'ลากิจ':
        return 1;
      case undefined:
        return -1;
    }
  }

  getStudListIdFromLocalStorage = () => {
    let res = JSON.parse(localStorage.getItem('datastorage')).filter((e) => e.studentid === this.props.location.state.sel_student.studentid);
    this.setState({
      curr_studlistid: res[0].persid,
      curr_persid: res[0].persid,
      courseid: res[0].CourseId,
    });
  }

  createIntructorList = async () => {
    const token = JSON.parse(localStorage.getItem('token')) 
    let res_instrlist = await axios.get(process.env.REACT_APP_API +`/PageUpdateAndRecordLeave/instructor?token=${token}`)
    .catch((err) => {
      if(err.response.data.message) {
        toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          this.props.navigate('/');
          localStorage.clear();
      } else {
        console.log("err: ", err.response.data)
      }
    })
    let instr_indx = res_instrlist.data.map((e) => { return e.instr_name }).indexOf(this.props.location.state.sel_student.persontakingtheleave);
    this.setState({ instrlist: res_instrlist.data, selinstr_indx: instr_indx });
  }

  /*-------------------------- Event -----------------------------*/
  handleCourseGrpSelect = (event, child) => {
    const arr = Object.values(child)[4].children.split(' ');
    this.setState({
      selcoursegrp: parseInt(arr[1]),
      selcoursegrp_indx: this.state.coursegrplist.findIndex((e) => e.includes(arr[1]))
    });
  }

  handleSeminarSelect = (event, child) => {
    const arr = Object.values(child)[4].children.split(' ');
    this.setState({
      selseminar: parseInt(arr[1]),
      selseminar_indx: this.state.seminarlist.findIndex((e) => e.includes(arr[1]))
    });
  }

  handleInstructorOnChange = (event, child) => {
    this.setState({ selinstr_indx: event.target.value });
  }

  handleLeaveTypeOnChange = (event, child) => {
    this.setState({ selleavetype_indx: event.target.value });
  }

  handleLeaveStartDateOnChange = (event, child) => {
    this.setState({ leavestartdate: event.target.value });
  }

  handleLeaveStartTimeOnChange = (event, child) => {
    this.setState({ leavestarttime: event.target.value });
  }

  handleLeaveEndDateOnChange = (event, child) => {
    this.setState({ leaveenddate: event.target.value });
  }

  handleLeaveEndTimeOnChange = (event, child) => {
    this.setState({ leaveendtime: event.target.value });
  }

  handleLeaveHrsOnChange = (event, child) => {
    this.setState({ leavehrs: event.target.value });
  }

  handleLeaveReasonOnchange = (event) => {
    this.setState({ leavereason: event.target.value });
  }

  /*--------------------- button to go back to previous page --------------------*/
  handleBtnGoBackOnClick = async (event, child) => {
    const CourseId = localStorage.getItem('AccessRights').substring(11, 14);
    if(CourseId === null) {
      toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
      // setTimeout(function() {
        this.props.navigate('/');
        // localStorage.clear();
      // }, delayInMilliseconds);
    }
    const token = JSON.parse(localStorage.getItem('token')) 
    //console.log('handleBtnGoBackOnClick >>> ', CourseId);
    let _coursegrp = this.props.location.state.sel_student.coursegrp;
    let _seminar = this.props.location.state.sel_student.seminar;
    await axios.get(process.env.REACT_APP_API + `/PageInsertScore/coursegrp/${_coursegrp}/${_seminar}/${CourseId}?token=${token}`)
      .then((results) => {
        //console.log('handleBtnGoBackOnClick >>> ', results.data);
        // let newarr = results.data.sort((a, b) => (a.studentid > b.studentid) ? 1 : ((b.studentid > a.studentid) ? -1 : 0));
        // newarr.map((e, i) => { e.id = (i + 1) });
        const sortSTU = results.data.sort((a, b) => {
          const numA = parseInt(a.studentid, 10);
          const numB = parseInt(b.studentid, 10);
          return numA - numB;}
          ); 
          const newarr = sortSTU.sort((a, b) => a.seminar - b.seminar); 
          // console.log("new: ", newarr);
        this.props.navigate('/PageEditInsertScore',
          {
            state:
            {
              id: this.state.curr_studlistid,
              prev_page: 1,
              newdatastorage: JSON.stringify(
                newarr.map((e) => Object.assign(e,
                  {
                    'courseid': CourseId, //// have to edit to get courseid from local storage or some sources
                    'coursegrp': _coursegrp,
                    'seminar': _seminar,
                    'pageinsertscore': 0
                  }
                )))
            }
          });
      })
      .catch((err) => {
        if(err.response.data.message) {
          toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
          // setTimeout(function() {
            this.props.navigate('/');
            localStorage.clear();
          // }, delayInMilliseconds);
        } else {
          console.log('cannot goback to previous page err : ', err);
        }
      })
  }

  /*--------------------- button to insert data into database ---------------------*/
  handleBtnRecOnClick = async (event, child) => {
    /*---------------- updated :: 26.08.2565 --------------------*/
    const CourseIds = localStorage.getItem('AccessRights').substring(11, 14)
    const user = localStorage.getItem('user')
    const UserId = JSON.parse(user)[0].PersId;
    if (
      // this.state.selinstr_indx !== -1 && 
      this.state.selleavetype_indx !== -1 &&
      this.state.leavereason !== undefined &&
      this.state.uploadfilepath !== '') {

      let _dataToDatabase = {
        'newleave': this.state.addnewleave,
        'PersId': this.state.curr_persid,
        /*-------------- updated :: 23.09.2022 -----------------*/
        'CourseId': CourseIds,
        /*------------------------------------------------------*/
        'ClassAttendId': this.state.classattendid,
        'BeginLeaveDate': this.state.leavestartdate,
        'BeginLeaveTime': this.state.leavestarttime,
        'EndLeaveDate': this.state.leaveenddate,
        'EndLeaveTime': this.state.leaveendtime,
        'LeaveHrs': this.state.leavehrs,
        /*'LeaveHrs': this.calDifferentDateAndTime(
          this.state.leavestartdate,
          this.state.leavestarttime,
          this.state.leaveenddate,
          this.state.leaveendtime),*/
        'LeaveType': this.state.selleavetype_indx,
        'Reason': this.state.leavereason,
        'filepath': await this.fileUploadRef.current.uploadFileProgress(),
        'InstructorId': UserId
      }

      //console.log('_dataToDatabase: ', _dataToDatabase)
      const token = JSON.parse(localStorage.getItem('token'))
      const token1 = localStorage.getItem('token')

      await axios.put(process.env.REACT_APP_API +`/PageUpdateAndRecordLeave/handleleavedata?token=${token1}`, _dataToDatabase)
        .then(async (res) => {
          let _coursegrp = this.props.location.state.sel_student.coursegrp;
          let _seminar = this.props.location.state.sel_student.seminar;
          await axios.get(process.env.REACT_APP_API +`/PageInsertScore/coursegrp/${_coursegrp}/${_seminar}/${CourseIds}?token=${token}`)
            .then((results) => {
              let newarr = results.data.sort((a, b) => (a.studentid > b.studentid) ? 1 : ((b.studentid > a.studentid) ? -1 : 0));
              newarr.map((e, i) => { e.id = (i + 1) });
              this.setState({
                loading: false,
                newlocalstorage: JSON.stringify(newarr.map((e) => Object.assign(e,
                  {
                    'courseid': CourseIds, //// have to edit to get courseid from local storage or some sources
                    'coursegrp': _coursegrp,
                    'seminar': _seminar,
                    'pageinsertscore': 0
                  }
                )))
              });
              console.log('tbclassattendance get data >> successful');
            })
            .catch((err) => {
              // if(err.response.status === 400) {
              //   toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
              //     this.props.navigate('/');
              //     localStorage.clear();
              // } else {
                console.log('tbclassattendance get data >> err : ', err);
              // }
            });
          toast.success("บันทึกข้อมูลสำเร็จ")
          console.log('tbclassattendance inserted or updated >> successful');
        })
        .catch((err) => {
          console.log('err.response: ', err.response);
          if(err.response.data.message) {
            toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไข หรือ เพิ่มข้อมูลอีกครั้ง");
            this.props.navigate('/');
            localStorage.clear();
          } else {
            toast.error("กรุณาเข้าระบบใหม่เพื่อแก้ไข หรือ เพิ่มข้อมูลอีกครั้ง");
            this.props.navigate('/');
            localStorage.clear();
            console.log('tbclassattendance inserted or updated >> err : ', err);
          }
          
        });

      if (!this.state.loading) {
        this.props.navigate('/PageEditInsertScore', {
          state: {
            id: this.state.curr_studlistid,
            prev_page: 1,
            newdatastorage: this.state.newlocalstorage,
          }
        });
      }
    } else {
      this.setOpenAlertDialog(true);
    }
  }

  calDifferentDateAndTime(s_date, s_time, e_date, e_time) {
    const timespan = new CalTimeSpan(s_date, s_time, e_date, e_time);
    return timespan.getTotalLeaveHrs();
  }

  /*---------------- updated :: 26.08.2565 --------------------*/
  setOpenAlertDialog = (state) => {
    this.setState({ openAlertDialog: state });
  }
  /*-----------------------------------------------------------*/

  render() {
    let res = JSON.parse(localStorage.getItem("PersonalHistory"));
    return (
      <div className='cotainerDetail'>
        <Container>
          <Grid container spacing={2}>
            {/*--------------- 1.row -----------------*/}
            <Grid item xs={10} >
              <Paper
                sx={{
                  display: 'flex',
                  height: 80,
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: 36,
                  fontWeight: 'bold',
                }}
                elevation={0}
              >
                ชั่วโมงการศึกษา และคะแนนความประพฤติ
              </Paper>
            </Grid>
            <Grid item xs={2} >
              <Paper
                sx={{
                  display: 'flex',
                  height: 80,
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
                elevation={0}
              >
                <Button
                  variant={'contained'}
                  sx={{
                    fontFamily: 'THSarabunNew',
                    fontWeight: 'bold',
                    fontSize: 16,
                  }}
                  startIcon={<ArrowCircleLeftIcon />}
                  onClick={this.handleBtnGoBackOnClick}
                >
                  ย้อนกลับ
                </Button>
              </Paper>
            </Grid>

            {/*--------------- 3.row -----------------*/}
            <Grid item xs={10} >
              <Paper
                sx={{
                  display: 'flex',
                  height: 80,
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: 28,
                  fontWeight: 'bold',
                }}
                elevation={0}
              >
                {this.state.addnewleave === 1 ? 'เพิ่มประวัติการลา' : 'แก้ไขประวัติการลา'}
              </Paper>
            </Grid>
            {/*--------------- 4.row -----------------*/}
            <Grid item xs={10} >
              <Grid container spacing={1}>
                {/*--------------- 4.1 ผู้ลงประวัติการลา-----------------*/}
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    ผู้ลงประวัติการลา :
                  </Paper>
                </Grid>
                <Grid item xs={10}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    {res[0].Rank + " " + res[0].PersFname + " " + res[0].PersLname}
                  </Paper>
                </Grid>

                {/*--------------- 4.2 เลขประจำตัวและชื่อ นทน. -----------------*/}
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    เลขประจำตัว นทน. :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    {this.props.location.state.sel_student.studentid}
                  </Paper>
                </Grid>
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    ชื่อ นทน. :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    {this.props.location.state.sel_student.studname}
                  </Paper>
                </Grid>
                {/*--------------- 4.3 เริ่มต้นการลา -----------------*/}
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    วันเริ่มต้นการลา :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    <OwnDatePickersWithFunc
                      action={
                        {
                          rec_date: this.props.location.state.sel_student.leavestartdate,
                          func: (newdate) => { this.setState({ leavestartdate: newdate }) }
                        }
                      }
                    />
                  </Paper>
                </Grid>
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    เวลาเริ่มต้นการลา :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    <OwnTimePickersWithFunc
                      rec_time={
                        {
                          _date: this.props.location.state.sel_student.leavestartdate,
                          _time: this.props.location.state.sel_student.leavestarttime,
                          func: (newtime) => { this.setState({ leavestarttime: newtime }) }
                        }
                      }
                    />
                  </Paper>
                </Grid>
                {/*--------------- 4.4 สิ้นสุดการลา -----------------*/}
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    วันสิ้นสุดการลา :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    <OwnDatePickersWithFunc
                      action={
                        {
                          rec_date: this.props.location.state.sel_student.leaveenddate,
                          func: (newdate) => { this.setState({ leaveenddate: newdate }) }
                        }
                      }
                    />
                  </Paper>
                </Grid>
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    เวลาสิ้นสุดการลา :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    <OwnTimePickersWithFunc
                      rec_time={
                        {
                          _date: this.props.location.state.sel_student.leaveenddate,
                          _time: this.props.location.state.sel_student.leaveendtime,
                          func: (newtime) => { this.setState({ leaveendtime: newtime }) }
                        }
                      }
                    />
                  </Paper>
                </Grid>
                {/*--------------- 4.5 ประเภทและจำนวนชั่วโมงการลา -----------------*/}
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    ประเภทการลา :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    <Select
                      value={this.state.selleavetype_indx}
                      id="leavetype" label="ประเภทการลา"
                      style={{ width: '70%' }}
                      onChange={this.handleLeaveTypeOnChange}
                    >
                      <MenuItem key={0} value={0} name={'ลาป่วย'}>ลาป่วย</MenuItem>
                      <MenuItem key={1} value={1} name={'ลากิจ'}>ลากิจ</MenuItem>
                    </Select>
                  </Paper>
                </Grid>

                 {/*------------ added on 04022023 ------------*/}
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    จำนวนชั่วโมงการลา :
                  </Paper>
                </Grid>
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      width: 100,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    <TextField
                      type='number'
                      value={this.state.leavehrs}
                      onChange={this.handleLeaveHrsOnChange}
                      InputProps={{
                        sx: {
                          "& input": {
                            textAlign: "center"
                          }
                        },
                        inputProps: { min: 0.0, step: 0.5 } 
                      }}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    ชั่วโมง
                  </Paper>
                </Grid>

                {/*--------------- 4.6 เหตุผลและเอกสารการลา -----------------*/}
                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    เหตุผลการลา :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Box
                    component="form"
                    sx={{ "&.MuiTextField-root": { m: 1, width: "30ch" } }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      sx={{ width: "100%" }}
                      defaultValue={this.state.leavereason}
                      multiline={true}
                      rows={3}
                      onChange={this.handleLeaveReasonOnchange}
                    />
                  </Box>

                </Grid>

                <Grid item xs={2}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                      fontWeight: 'bold',
                    }}
                    elevation={0}
                  >
                    เอกสารการลา :
                  </Paper>
                </Grid>
                <Grid item xs={4}>
                  <Paper
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                    elevation={0}
                  >
                    <FileUpload
                      ref={this.fileUploadRef}
                      data={{
                        _props: this.props,
                        func: (path) => {
                          this.setState({ uploadfilepath: path });
                        },
                      }}
                    />
                  </Paper>
                </Grid>

                {/*--------------- 4.7 ปุ่มย้อนกลับและบันทึก -----------------*/}
                <Grid item xs={6}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      fontSize: 16,
                    }}
                    elevation={0}
                  >
                    <Button
                      variant={'contained'}
                      sx={{
                        fontFamily: 'THSarabunNew',
                        fontWeight: 'bold',
                        fontSize: 16,
                      }}
                      startIcon={<ArrowCircleLeftIcon />}
                      onClick={this.handleBtnGoBackOnClick}
                    >
                      ย้อนกลับ
                    </Button>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper
                    sx={{
                      display: 'flex',
                      height: 80,
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                    elevation={0}
                  >
                    <Button
                      variant={'contained'}
                      sx={{
                        fontFamily: 'THSarabunNew',
                        fontWeight: 'bold',
                        fontSize: 16,
                      }}
                      startIcon={<SaveIcon />}
                      onClick={this.handleBtnRecOnClick}
                    >
                      บันทึก
                    </Button>
                  </Paper>
                </Grid>

              </Grid>
            </Grid>
          </Grid>
        </Container>
        {
          /*---------------- add :: 26.08.2565 --------------------*/
          this.state.openAlertDialog &&
          <AlertDialog
            title='แจ้งเตือน'
            content={'กรุณาตรวจสอบและกรอกข้อมูลที่กำหนดให้ครบถ้วน'}
            openDialog={this.state.openAlertDialog}
            setOpenDialog={this.setOpenAlertDialog}
          />
        }
      </div >
    ); //end return
  }//end render
}

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
  <PageUpdateAndRecordLeave location={useLocation()} navigate={useNavigate()} />
);


